<template>
  <div>
    <el-form :inline="true" size="small" class="u-mb-10">
      <el-form-item label="De">
        <el-date-picker v-model="de" type="date" value-format="yyyy-MM-dd" @change="carregar"></el-date-picker>
      </el-form-item>
      <el-form-item label="Até">
        <el-date-picker v-model="ate" type="date" value-format="yyyy-MM-dd" @change="carregar"></el-date-picker>
      </el-form-item>
      <el-form-item label="Canal">
        <el-select v-model="canal" clearable placeholder="todos" style="width:140px" @change="carregar">
          <el-option label="site" value="site"></el-option>
          <el-option label="whatsapp" value="whatsapp"></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div v-if="carregando" class="estado" data-test="carregando"><i class="el-icon-loading"></i> carregando…</div>
    <el-alert v-else-if="erro" type="error" :closable="false" show-icon data-test="erro" :title="erro"></el-alert>

    <template v-else>
      <!-- ============ AV 8 — duração REAL ============ -->
      <el-alert type="info" :closable="false" show-icon class="u-mb-10">
        <div slot="title">Atendimento em menos de 15 minutos (AV 8)</div>
        <div class="obs">
          Medido por <b>duração real</b> (início → encerramento) das sessões CONCLUÍDAS.
          Interrompidas e expiradas ficam em série separada — misturá-las inflaria o número.
        </div>
      </el-alert>

      <el-row :gutter="10" class="u-mb-10">
        <el-col :xs="12" :sm="6"><div class="cartao">
          <div class="rot">Concluídas</div>
          <div class="val" data-test="total-concluidas">{{ c.total }}</div>
        </div></el-col>
        <el-col :xs="12" :sm="6"><div class="cartao destaque">
          <div class="rot">Dentro de 15 min</div>
          <div class="val" data-test="percentual-15">{{ c.percentual_dentro_15min === null ? '—' : c.percentual_dentro_15min + '%' }}</div>
          <div class="obs">{{ c.dentro_15min }} de {{ c.total }}</div>
        </div></el-col>
        <el-col :xs="12" :sm="6"><div class="cartao">
          <div class="rot">Mediana</div>
          <div class="val" data-test="mediana">{{ fmt(c.mediana_s) }}</div>
        </div></el-col>
        <el-col :xs="12" :sm="6"><div class="cartao">
          <div class="rot">p95</div>
          <div class="val" data-test="p95">{{ fmt(c.p95_s) }}</div>
        </div></el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :xs="24" :sm="8">
          <c-panel title="Não concluídas (série separada)" titleIcon="fas fa-ban">
            <table class="table table-striped" data-test="nao-concluidas">
              <tr v-for="n in dados.nao_concluidas" :key="n.estado">
                <td>{{ n.estado }}</td><td style="width:70px">{{ n.qtd }}</td>
              </tr>
              <tr v-if="!dados.nao_concluidas || !dados.nao_concluidas.length">
                <td colspan="2" class="obs">nenhuma no período</td>
              </tr>
            </table>
          </c-panel>
        </el-col>
        <el-col :xs="24" :sm="8">
          <!--
            AV 11 — a pesquisa de satisfação só cumpre o requisito quando alguém VÊ o
            resultado. A distribuição fica ao lado da média porque média isolada esconde
            polarização: metade nota 1 e metade nota 5 dá a mesma média de tudo nota 3.
          -->
          <c-panel title="Satisfação (AV 11)" titleIcon="fas fa-star">
            <div class="cartao" style="margin-bottom:6px">
              <div class="rot">nota média</div>
              <div class="val" data-test="satisfacao-media">{{ satisfacao.media === null || satisfacao.media === undefined ? '—' : satisfacao.media }}</div>
              <div class="obs" data-test="satisfacao-respondidas">{{ satisfacao.respondidas || 0 }} de {{ (dados.concluidas && dados.concluidas.total) || 0 }} responderam</div>
            </div>
            <table class="table table-striped" data-test="satisfacao-distribuicao">
              <tr v-for="nota in [5, 4, 3, 2, 1]" :key="nota">
                <td>{{ nota }} estrela(s)</td>
                <td style="width:70px">{{ (satisfacao.distribuicao && satisfacao.distribuicao[nota]) || 0 }}</td>
              </tr>
            </table>
          </c-panel>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :xs="24" :sm="8">
          <c-panel title="Por canal (AV 2)" titleIcon="fas fa-comments">
            <table class="table table-striped" data-test="por-canal">
              <tr v-for="x in dados.por_canal" :key="x.canal"><td>{{ x.canal }}</td><td style="width:70px">{{ x.qtd }}</td></tr>
            </table>
          </c-panel>
        </el-col>
        <el-col :xs="24" :sm="8">
          <c-panel title="Por origem (AV 28)" titleIcon="fas fa-link">
            <table class="table table-striped" data-test="por-origem">
              <tr v-for="x in dados.por_origem" :key="x.origem"><td>{{ x.origem }}</td><td style="width:70px">{{ x.qtd }}</td></tr>
              <tr v-if="!dados.por_origem || !dados.por_origem.length">
                <td colspan="2" class="obs">nenhuma origem registrada</td>
              </tr>
            </table>
          </c-panel>
        </el-col>
      </el-row>

      <c-panel title="Sessões" titleIcon="fas fa-list" class="u-mt-10">
        <table class="table table-striped" data-test="tabela-sessoes">
          <thead><tr><th>#</th><th>Canal</th><th>Estado</th><th>Identidade</th>
                     <th>Início</th><th>Fim</th><th>Protocolo</th><th></th></tr></thead>
          <tbody>
            <tr v-for="s in sessoes" :key="s.id">
              <td>{{ s.id }}</td><td>{{ s.canal }}</td>
              <td><el-tag size="mini" :type="s.estado === 'concluida' ? 'success' : 'info'">{{ s.estado }}</el-tag></td>
              <td>{{ s.nivel_identidade }}</td>
              <td>{{ s.iniciado_em }}</td><td>{{ s.encerrado_em || '—' }}</td>
              <td>{{ s.protocolo || '—' }}</td>
              <td>
                <el-button v-if="!s.encerrado_em" type="text" size="mini"
                           @click="encerrar(s)" data-test="btn-encerrar-sessao">encerrar</el-button>
              </td>
            </tr>
          </tbody>
        </table>
      </c-panel>
    </template>
  </div>
</template>

<script>
/** FASE 5 / AV-3 — AV 2 e 8: painel de atendimentos, com duração real. */
import assistenteApi from '../assistenteApi'

export default {
  data () {
    return {
      api: null, dados: {}, sessoes: [], carregando: false, erro: null,
      de: null, ate: null, canal: null
    }
  },
  computed: {
    c () { return (this.dados && this.dados.concluidas) || {}
    },
    /* AV 11 — o painel tem de sobreviver a um período sem nenhuma resposta. */
    satisfacao () {
      return (this.dados && this.dados.satisfacao) ||
             { respondidas: 0, media: null, distribuicao: {} }
    }
  },
  mounted () {
    this.api = assistenteApi.criar({ axios: this.$axios, base: this.base(), auth: this.auth() })
    this.carregar()
  },
  methods: {
    base () { return this.$store.state.config.baseUrlApi },
    auth () { return this.$store.getters.getHeaderAuth },

    textoErro (e) {
      const r = e && e.response ? e.response : null
      if (!r) return 'Falha de comunicação com o servidor.'
      if (r.data && typeof r.data.erro === 'string') return r.data.erro
      if (r.data && r.data.erro && r.data.erro.text) return r.data.erro.text
      return 'Erro ' + r.status + ' ao consultar o servidor.'
    },

    fmt (s) {
      if (s === null || s === undefined) return '—'
      const m = Math.floor(s / 60)
      return m > 0 ? m + 'm ' + (s % 60) + 's' : s + 's'
    },

    carregar () {
      const self = this
      this.carregando = true
      this.erro = null

      this.api.painel({ de: this.de, ate: this.ate, canal: this.canal }).then(function (r) {
        self.dados = r.data || {}
        self.carregando = false
        self.carregarSessoes()
      }).catch(function (e) {
        self.carregando = false
        self.erro = self.textoErro(e)
      })
    },

    carregarSessoes () {
      const self = this
      this.api.sessoes({ canal: this.canal }).then(function (r) {
        self.sessoes = (r.data && r.data.data) || r.data || []
      }).catch(function () {})
    },

    encerrar (s) {
      const self = this
      this.api.encerrarSessao(s.id).then(function () { self.carregar() })
    }
  }
}
</script>

<style scoped>
.estado { padding: 24px; text-align: center; color: #909399; }
.cartao { background: #f5f7fa; border-radius: 4px; padding: 12px; text-align: center; }
.cartao.destaque { background: #ecf5ff; }
.rot { font-size: 11px; color: #909399; }
.val { font-size: 24px; font-weight: 600; }
.obs { font-size: 11px; color: #909399; }
</style>
